var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('color-strip');
import { breakpoints, theme } from '@shapeable/theme';
export var ColorStripDefaultProps = {
  colors: [],
  height: '6px'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    font-size: 0;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    font-size: 0;\n  "])))
});
var ColorStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _height = _a._height,
        _color = _a._color,
        _width = _a._width;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: ", ";\n      height: ", ";\n      background-color: ", ";\n    "], ["\n      width: ", ";\n      height: ", ";\n      background-color: ", ";\n    "])), _width, _height, theme.COLOR(_color));
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Color: styled.span.attrs(cls.attr('color'))(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ColorStyles)
};
export var ColorStrip = function ColorStrip(props) {
  var className = props.className,
      colors = props.colors,
      height = props.height;

  if (!colors.length) {
    return null;
  }

  var itemWidth = 1 / colors.length * 100 + "%";
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, colors.map(function (color, index) {
    return React.createElement(My.Color, {
      _height: height,
      _color: color,
      _width: itemWidth,
      key: "color-" + color + "-" + index
    });
  }));
};
ColorStrip.defaultProps = ColorStripDefaultProps;
ColorStrip.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;